module.exports = __webpack_public_path__ + "img/plus-canvas-card.b2a67007.svg";